import React from "react";
import EmailTemplateList from "../../Components/EmailTemplateList";

const EmailTemplates = () => {
  return <EmailTemplateList />;
};

export default EmailTemplates;
